/* =================== SLIDE HOME =================== */
jQuery(document).ready(function ($) {
  $(".slide-home").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    fade: true,
    cssEase: "linear",
    speed: 1200,
  });
});
